import React from 'react'
import { type VictoryTooltipProps, VictoryTooltip } from 'victory'
import { tooltipFlyoutStyle } from 'legacy/components/DataViz/Charts/CommonChartStyles'

class LabelTooltip extends React.Component<VictoryTooltipProps> {
  // https://formidable.com/open-source/victory/guides/tooltips#wrapping-victorytooltip
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  static defaultEvents = (VictoryTooltip as any).defaultEvents

  render() {
    return <VictoryTooltip {...this.props} pointerLength={0} flyoutStyle={tooltipFlyoutStyle} />
  }
}

export default LabelTooltip
